/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpvisibilitywarning_Title3Inputs */

const en_coinvestments_lpvisibilitywarning_title3 = /** @type {(inputs: Coinvestments_Lpvisibilitywarning_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation Visibility`)
};

/**
* | output |
* | --- |
* | "Organisation Visibility" |
*
* @param {Coinvestments_Lpvisibilitywarning_Title3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpvisibilitywarning_title3 = /** @type {((inputs?: Coinvestments_Lpvisibilitywarning_Title3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpvisibilitywarning_Title3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpvisibilitywarning_title3(inputs)
});
export { coinvestments_lpvisibilitywarning_title3 as "coInvestments_lpVisibilityWarning_title" }